import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import moment from 'moment';
import { actionType } from './constants';
import { times } from '@/utils/calc-fns';
import { JobTargetStatus, JobAwardTypeStatus, JobTypeStatus } from './type';

const model = {
  state: {
    jobId: null,
    // 任务列表
    taskQueryParams: {
      channel: '',
      time: [],
      city: '',
      cbd: '',
      company: '',
      per_page: 10,
      cur_page: 1,
    },
    taskListLoading: false,
    taskList: [],
    taskListTotal: 0,
    taskDetail: {},
    // taskcoupon
    taskCouponList: [], // 优惠券list
    taskCouponLoading: false,
    taskCouponVisible: false,
    // 操作状态
    addEditType: 'add',
    // coupon
    selectedCouponList: [],
    ActivityCouponList: [],
    // 任务详情优惠券
    userCouponList: [],
    userCouponTotal: 0,
    taskDetailVisible: false,
    detailParams: {
      pageSize: 5,
      pageNum: 1,
      type: 0,
    },
    saveLoading: false, // 保存时loading状态，用于禁止按钮多次点击
    ladderTaskList: [], // 子任务列表
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { marketingTaskCenter, basic }, getState }) => ({
    // 任务列表
    async getTaskList() {
      const { taskQueryParams } = getState().marketingTaskCenter;
      marketingTaskCenter.setState({ taskListLoading: true });
      const data = await fetch('/saasmerchant/web/marketjob/marketJobList', {
        type: 'GET',
        params: {
          jobChannel: taskQueryParams.channel,
          beginTime:
            taskQueryParams?.time?.[0] &&
            moment(taskQueryParams.time[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime:
            taskQueryParams?.time?.[1] &&
            moment(taskQueryParams.time[1]).format('YYYY-MM-DD HH:mm:ss'),
          cityName: taskQueryParams.city,
          businessDistricName: taskQueryParams.cbd,
          companyName: taskQueryParams.company,
          pageSize: taskQueryParams.per_page,
          pageNum: taskQueryParams.cur_page,
        },
      });
      marketingTaskCenter.setState({ taskListLoading: false });
      if (data) {
        marketingTaskCenter.setState({
          taskList: data.list || [],
          taskListTotal: data.total || 0,
        });
      }
    },
    onTaskSearch(taskQueryParams) {
      marketingTaskCenter.setState({ taskQueryParams });
      marketingTaskCenter.getTaskList();
    },
    onTaskReset() {
      marketingTaskCenter.setState({
        taskQueryParams: {
          channel: '',
          time: [],
          city: '',
          cbd: '',
          company: '',
          per_page: 10,
          cur_page: 1,
        },
      });
    },
    onTaskNav(page) {
      const { taskQueryParams } = getState().marketingTaskCenter;
      marketingTaskCenter.setState({ taskQueryParams: { ...taskQueryParams, cur_page: page } });
      marketingTaskCenter.getTaskList();
    },
    // 任务操作
    async getTaskCoupon(jobId) {
      marketingTaskCenter.setState({ taskCouponLoading: true });
      const data = await fetch('/saasmerchant/web/marketjob/getAward', {
        type: 'GET',
        params: filterNull({
          jobId,
        }),
      });
      marketingTaskCenter.setState({ taskCouponLoading: false });
      if (data) {
        marketingTaskCenter.setState({
          taskCouponList: data,
        });
      }
    },
    async getTaskDetail(jobId) {
      const data = await fetch('/saasmerchant/web/marketjob/marketJobDetail', {
        type: 'GET',
        params: filterNull({
          jobId,
        }),
      });
      if (data) {
        marketingTaskCenter.setState({
          taskDetail: data,
        });
      }
      return data;
    },
    setTaskDetailVisible(visible) {
      marketingTaskCenter.setState({ taskDetailVisible: visible });
    },
    setTaskCouponVisible(isShow) {
      marketingTaskCenter.setState({
        taskCouponVisible: isShow,
      });
    },
    setQueryParams(params) {
      const { taskQueryParams } = getState().marketingTaskCenter;
      marketingTaskCenter.setState({ taskQueryParams: { ...taskQueryParams, ...params } });
    },
    async updataTaskStatus(jobId, status) {
      let url;
      let p;
      if (status === 'stop') {
        url = '/saasmerchant/web/marketjob/stopMarketJob';
        p = {
          jobId,
          isStoped: 1,
        };
      } else {
        url = '/saasmerchant/web/marketjob/delMarketJob';
        p = {
          jobId,
          isDeleted: 1,
        };
      }
      const data = await fetch(url, {
        type: 'GET',
        params: {
          ...p,
          jobId,
        },
      });
      if (data) {
        marketingTaskCenter.getTaskList();
      }
    },
    // 详情任务对象列表
    async getDetailJobTargetList(marketJobId, pageNo, pageSize) {
      const data = await fetch('/saasmerchant/web/marketjob/listMarketJobTarget', {
        type: 'GET',
        params: { marketJobId, pageNo, pageSize },
      });
      return data || [];
    },
    // 详情黑名单列表
    async getDetailBlackList(marketJobId, pageNo, pageSize) {
      const data = await fetch('/saasmerchant/web/marketjob/listBlackMarketJobTarget', {
        type: 'GET',
        params: { marketJobId, pageNo, pageSize },
      });
      return data || [];
    },
    // 详情任务奖励列表
    async getDetailAwardList(marketJobId, pageNo, pageSize) {
      const data = await fetch('/saasmerchant/web/marketjob/listMarketJobAwardLog', {
        type: 'GET',
        params: { marketJobId, pageNo, pageSize },
      });
      return data || [];
    },
    setLadderTaskList(ladderTaskList) {
      marketingTaskCenter.setState({ ladderTaskList });
    },
    async getLadderTaskList(jobId) {
      const data = await fetch('/saasmerchant/web/marketjob/childJobs', {
        type: 'GET',
        params: {
          jobId,
        },
      });
      marketingTaskCenter.setLadderTaskList(data || []);
    },
    // 详情下载任务奖励
    async exportDetailAwardList(marketJobId) {
      const data = await fetch('/saasmerchant/web/marketjob/downLoad/marketJobAwardLog', {
        type: 'GET',
        params: { marketJobId },
      });
      if (data) {
        message.success('导出成功');
        basic.setLogListDot(true);
      }
    },
    // 任务详情优惠券
    async getTaskDetailUserCoupon(jobId) {
      const { detailParams } = getState().marketingTaskCenter;
      const data = await fetch('/saasmerchant/web/marketjob/marketJobCoupons', {
        type: 'GET',
        params: { ...filterNull(detailParams), jobId },
      });
      if (data) {
        marketingTaskCenter.setState({
          userCouponList: data.list || [],
          userCouponTotal: data.total || 0,
        });
      }
      return data;
    },
    onDetailReset() {
      marketingTaskCenter.setState({
        detailParams: {
          pageSize: 5,
          pageNum: 1,
          type: 0,
        },
      });
    },
    onDetailNav(page) {
      const { detailParams } = getState().marketingTaskCenter;
      marketingTaskCenter.setState({ detailParams: { ...detailParams, pageNum: page } });
    },
    onTaskDetailTabsChange(status) {
      const { detailParams } = getState().marketingTaskCenter;
      marketingTaskCenter.setState({
        detailParams: {
          ...detailParams,
          pageNum: 1,
          type: status,
        },
      });
    },
    async exportCoupon(jobId) {
      const { detailParams } = getState().marketingTaskCenter;
      const data = await fetch('/saasmerchant/web/marketjob/exportJobCoupons', {
        params: filterNull({
          type: detailParams.type,
          jobId,
        }),
      });
      if (data) {
        message.success('导出成功');
        basic.setLogListDot(true);
      }
    },
    // 选择活动
    async getActivity(params) {
      let data = await fetch('/saasmerchant/web/activityConfig/getActivityConfigForAdmin', {
        type: 'GET',
        params: {
          ...params,
          title: params.searchParam,
          timeStatus: params.selectParam,
          type: 1,
        },
      });
      data = data || {};
      return {
        total: data.total || 0,
        list: data.records || [],
      };
    },
    async getActivityCoupon(activityConfigId) {
      const data = await fetch('/saasmerchant/web/activityConfig/getCouponByActivityId', {
        type: 'GET',
        params: filterNull({
          activityId: activityConfigId,
        }),
      });
      if (data) {
        marketingTaskCenter.setState({
          ActivityCouponList: data,
        });
      } else {
        marketingTaskCenter.setState({
          ActivityCouponList: [],
        });
      }
    },
    // 选择用户
    setSelectedUserList(selected) {
      marketingTaskCenter.setState({
        selectedUserList: selected,
      });
    },
    async getUsers(params) {
      const data = await fetch('/marketing/platformcoupon/searchEmployee', {
        type: 'GET',
        params: {
          ...params,
          phone: params.searchParam,
          union_shop_id: 15998082420222,
          shop_id: 15998082420222,
        },
      });
      return {
        total: (data && data.length) || 0,
        list: data
          ? data.map((item) => {
              return {
                ...item,
                mainKey: `${item.user_id}.${item.employee_name}.${item.employee_phone}`,
              };
            })
          : [],
      };
    },
    async getCustomerGroupList(params) {
      const data = await fetch('/saasmerchant/web/customergroup/pageList', {
        type: 'POST',
        useJson: true,
        params: filterNull({
          groupName: params.searchParam,
          cityCodes: params.selectCity,
          status: 0,
          auditStatus: 1,
          pageNo: params.pageNum,
          pageSize: params.pageSize,
        }),
      });
      return {
        total: data.total,
        list:
          data.list.map((item) => {
            return {
              ...item,
              mainKey: `${item.groupId}`,
            };
          }) || [],
      };
    },
    // 选择优惠券
    async getCouponList(params) {
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/getCouponsByName', {
        type: 'GET',
        params: {
          ...params,
          name: params.searchParam,
        },
      });
      return {
        total: (data && data.length) || 0,
        list: data || [],
      };
    },
    setSelectedCouponList(selectedCouponList) {
      marketingTaskCenter.setState({
        selectedCouponList,
      });
    },

    handleChildTaskParams(params) {
      const newParams = params.map((item, index) => {
        item.order = index + 1;
        return {
          jobType: item.jobType,
          jobName: item.jobName,
          jobDesc: item.jobDesc,
          order: item.order,
          awardType: item.awardType,
          jobTypeDesc:
            item.jobType === JobTypeStatus.REPURCHASE
              ? marketingTaskCenter.handleJobTypeDesc(item)
              : undefined,
          award:
            item.awardType === JobAwardTypeStatus.COUPON
              ? marketingTaskCenter.handleCoupon(item.award)
              : [{ awardAmount: times(item.awardAmount, 100) }],
        };
      });
      return newParams;
    },
    handleCoupon(couponList) {
      const res = couponList.map((coupon) => {
        return {
          awardId: coupon.platformCouponBatchId,
          awardName: coupon.platformCouponName,
          // 没有手动更改coupon.awardNum就是undefined
          awardNum: coupon.awardNum || 1,
          repeatLimit: coupon.repeatLimit,
        };
      });
      return res;
    },
    // 复购任务的任务详情
    handleJobTypeDesc(params) {
      return filterNull({
        activityId: params.activity?.[0] && params.activity[0].activityConfigId,
        activityName: params.activity?.[0] && params.activity[0].title,
        jobTypeWay: params.jobTypeWay,
        orderNum: params.orderNum,
        continuousDayNum: params.continuousDayNum,
        continuousOrderNum: params.continuousOrderNum,
        isRepeated: params.isRepeated,
        repeatNum: params.jobType === JobTypeStatus.REPURCHASE ? params.repeatNum : undefined,
        dispatchMethod: params.dispatchMethod?.length > 1 ? 0 : params.dispatchMethod?.[0],
        orderLimitAmount: times(params.orderLimitAmount, 100),
        amountLimited: params.amountLimited,
      });
    },
    // 保存任务
    async saveTask(params, history, jobId) {
      marketingTaskCenter.setState({ saveLoading: true });
      const { addEditType } = getState().marketingTaskCenter;
      const jobTypeDesc = marketingTaskCenter.handleJobTypeDesc(params);
      const allParams = {
        jobId,
        jobName: params.jobName,
        jobDesc: params.jobDesc,
        beginTime: moment(params.time[0]).format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(params.time[1]).format('YYYY-MM-DD HH:mm:ss'),
        jobChannel: params.jobChannel.join(','),
        jobTarget: params.jobTarget,
        blackTarget: params.blackTarget,
        jobBlackTarget: params.jobBlackTarget,
        target: params.target,
        jobType: params.jobType,
        jobTypeDesc: params.jobType === JobTypeStatus.LADDER ? undefined : jobTypeDesc,
        awardType: params.awardType,
        userType: params.userType,
        // params.jobType === JobTypeStatus.LADDER
        //   ? undefined
        //   : params.jobType === JobTypeStatus.COMPANY || params.jobType === JobTypeStatus.GROUP
        //   ? params.awardType
        //   : JobAwardTypeStatus.COUPON, // 默认优惠券
        award:
          params.jobType === JobTypeStatus.LADDER
            ? undefined
            : params.awardType === JobAwardTypeStatus.COUPON || params.awardType === undefined // 老活动默认优惠券，饭圈和企业拉新选优惠券才传
            ? marketingTaskCenter.handleCoupon(params.coupon)
            : params.awardType === JobAwardTypeStatus.MONEY
            ? [
                {
                  awardAmount: times(params.awardAmount, 100),
                  inviteMaxCount: params.inviteMaxCount,
                  minPayAmount: times(params.minPayAmount, 100),
                },
              ]
            : [],
        ladderChildJobs:
          params.ladderChildJobs &&
          marketingTaskCenter.handleChildTaskParams(params.ladderChildJobs),
        targetSource: 'LADDER_JOB', // 组件写死
      };
      const data = await fetch(actionType[addEditType].requestUrl, {
        type: 'POST',
        params: allParams,
        useJson: true,
      });
      marketingTaskCenter.setState({ saveLoading: false });
      if (data) {
        message.success(`任务${actionType[addEditType].name}成功`);
        history.push('/marketing/tool/task-center');
      }
    },
    // 设置操作状态
    setAddEditType(type, id = '') {
      marketingTaskCenter.setState({ addEditType: type, jobId: id });
    },
    async getLadderChildTaskList(jobId) {
      const list = await fetch('/saasmerchant/web/marketjob/childJobs', {
        type: 'GET',
        params: {
          jobId,
        },
      });
      return list || [];
    },
  }),
};

export default model;
